import { Target } from "react-feather"
import { useNavigate } from "react-router-dom"


export const Footer = () => {
    const navigate = useNavigate()

    return (
        <>
            <div className="row footer p-lg-3 p-4" id="Contact">

                <div className="col-12 col-lg-4 px-lg-5 text-center">
                    <a href="javascript:void(0)"
                        onClick={() => navigate('/')}>
                        <img src="Static/Assets/Img/logo.png" alt="logo here" className="logo_bg2" />
                    </a>
                    <h5 className="text-white pt-4">Marine Insurance Learning and Sharing Online <br />( MILSO )</h5>
                </div>

                <div className="col-12 col-lg-3 mt-5">
                    <div className="ps-lg-4 py-3 ">
                        <div className=" bounce" id="hover_effect">
                            <h6 className="fw-bold text-white fs-7">
                                <img src="/Static/Assets/Img/location.png" className="me-2 footer_icons mb-1"
                                    style={{ height: '17px' }}
                                />
                                Address
                            </h6>
                            <p className="pt-1 faintcolor">
                                Anuradha More and Associates, <br />
                                204 Gurukrupa CHS,
                                Nehru Nagar, <br />
                                Kurla (E)
                                Mumbai 400024
                            </p>
                        </div>

                    </div>

                </div>
                <div className="col-12 col-lg-3 mt-5 bounce" id="hover_effect">
                    <span className="fw-bold text-white pb-3  pt-3 fs-7">
                        <img src="/Static/Assets/Img/email.png" className="me-2 footer_icons mb-1"
                            style={{ height: '17px' }}
                        />
                        Email Address</span>
                    <p className=" pt-1" style={{ textAlign: 'justify' }}>
                        <a href="mailto:Anuradhamore.associaes@gmail.com" className="faintcolor">
                            milsoconnect1@gmail.com</a>
                    </p>

                    <div className=" bounce" id="hover_effect">
                        <span className="fw-bold text-white pb-3  pt-3 fs-7">
                            <img src="/Static/Assets/Img/calling.png" className="me-2 footer_icons mb-1"
                                style={{ height: '15px' }}
                            />
                            Mobile Number</span>
                        <p className="pt-1" style={{ textAlign: 'justify' }}>
                            <a href="tel:8218088830" className="faintcolor">+91 82180 88830</a>
                        </p>
                    </div>
                </div>
                <div className="col-12 col-lg-2 mt-5 " id="hover_effect">

                    <span className="fw-bold text-white pb-3 pt-3 fs-7">
                        <img src="/Static/Assets/Img/privacy-policy.png" className="me-2 footer_icons mb-1"
                            style={{ height: '17px' }}
                        />
                        Policy
                    </span>
                    <p className="pt-1 faintcolor cursor-pointer"
                        title="Click to View Privacy Policy"
                        onClick={() => window.open('https://milso.co.in/policy.html')}
                    >
                        Privacy Policy
                    </p>
                    <p className="pt-0 faintcolor cursor-pointer"
                        title="Click to View Terms & Conditions Policy"
                        onClick={() => window.open('https://milso.co.in/terms-and-conditions.html')}
                    >
                        Terms & Conditions
                    </p>
                    <p className="pt-0 faintcolor cursor-pointer"
                        title="Click to View Refund Policy"
                        onClick={() => window.open('https://milso.co.in/refund-policy.html')}
                    >
                        Refund Policy
                    </p>
                    <p className="pt-0 faintcolor cursor-pointer"
                        title="Click to View Cancellation Policy"
                        onClick={() => window.open('https://milso.co.in/cancellation-policy.html')}
                    >
                        Cancellation Policy
                    </p>

                </div>
                <hr className="text-white" />
                <p className="text-center text-white pt-3">© Copyright MILSO All Rights Reserved.</p>
            </div>

        </>
    )
}